var IconTypes;
(function (IconTypes) {
    IconTypes["analytics"] = "analytics";
    IconTypes["arrowDown"] = "arrowDown";
    IconTypes["arrowLeft"] = "arrowLeft";
    IconTypes["arrowRight"] = "arrowRight";
    IconTypes["arrowUp"] = "arrowUp";
    IconTypes["bin"] = "bin";
    IconTypes["bookmark"] = "bookmark";
    IconTypes["bookmarkFill"] = "bookmarkFill";
    IconTypes["calendar"] = "calendar";
    IconTypes["categories"] = "categories";
    IconTypes["checklist"] = "checklist";
    IconTypes["chevronDown"] = "chevronDown";
    IconTypes["chevronLeft"] = "chevronLeft";
    IconTypes["chevronRight"] = "chevronRight";
    IconTypes["chevronUp"] = "chevronUp";
    IconTypes["circleAlert"] = "circleAlert";
    IconTypes["circleAlertFill"] = "circleAlertFill";
    IconTypes["circleCrossFill"] = "circleCrossFill";
    IconTypes["circleDisable"] = "circleDisable";
    IconTypes["circleFastForward"] = "circleFastForward";
    IconTypes["circleInformation"] = "circleInformation";
    IconTypes["circlePause"] = "circlePause";
    IconTypes["circlePlay"] = "circlePlay";
    IconTypes["circleQuestion"] = "circleQuestion";
    IconTypes["circleTickFill"] = "circleTickFill";
    IconTypes["companyBenefit"] = "companyBenefit";
    IconTypes["cross"] = "cross";
    IconTypes["document"] = "document";
    IconTypes["downloadReport"] = "downloadReport";
    IconTypes["edit"] = "edit";
    IconTypes["email"] = "email";
    IconTypes["export"] = "export";
    IconTypes["eye"] = "eye";
    IconTypes["eyeDisabled"] = "eyeDisabled";
    IconTypes["favourite"] = "favourite";
    IconTypes["favouriteFill"] = "favouriteFill";
    IconTypes["funnel"] = "funnel";
    IconTypes["filter1"] = "filter1";
    IconTypes["filter2"] = "filter2";
    IconTypes["filter3"] = "filter3";
    IconTypes["filterHighToLow"] = "filterHighToLow";
    IconTypes["filterLowToHigh"] = "filterLowToHigh";
    IconTypes["filterUpAndDown"] = "filterUpAndDown";
    IconTypes["generateReport"] = "generateReport";
    IconTypes["information"] = "information";
    IconTypes["label"] = "label";
    IconTypes["lightBulb"] = "lightBulb";
    IconTypes["location"] = "location";
    IconTypes["minus"] = "minus";
    IconTypes["notification"] = "notification";
    IconTypes["pending"] = "pending";
    IconTypes["plus"] = "plus";
    IconTypes["profile"] = "profile";
    IconTypes["results"] = "results";
    IconTypes["reward"] = "reward";
    IconTypes["reward2"] = "reward2";
    IconTypes["search"] = "search";
    IconTypes["send"] = "send";
    IconTypes["settings"] = "settings";
    IconTypes["speech"] = "speech";
    IconTypes["speechPlus"] = "speechPlus";
    IconTypes["star"] = "star";
    IconTypes["starFill"] = "starFill";
    IconTypes["survey"] = "survey";
    IconTypes["tick"] = "tick";
    IconTypes["uploadReport"] = "uploadReport";
    IconTypes["wallet"] = "wallet";
    // === old icons below ===
    IconTypes["addAdmin"] = "addAdmin";
    IconTypes["addBookmark"] = "addBookmark";
    IconTypes["addComment"] = "addComment";
    IconTypes["addEmoji"] = "addEmoji";
    IconTypes["addReward"] = "addReward";
    IconTypes["adminCustomisation"] = "adminCustomisation";
    IconTypes["adminHelp"] = "adminHelp";
    IconTypes["adminLoginIntegrations"] = "adminLoginIntegrations";
    IconTypes["adminMyPeople"] = "adminMyPeople";
    IconTypes["adminMyTeam"] = "adminMyTeam";
    IconTypes["adminReports"] = "adminReports";
    IconTypes["adminRolesPermission"] = "adminRolesPermissions";
    IconTypes["angleLeft"] = "angleLeft";
    IconTypes["angleRight"] = "angleRight";
    IconTypes["announcement"] = "announcement";
    IconTypes["apps"] = "apps";
    IconTypes["archive"] = "archive";
    IconTypes["attachment"] = "attachment";
    IconTypes["backArrow"] = "backArrow";
    IconTypes["blog"] = "blog";
    IconTypes["circleHollow"] = "circleHollow";
    IconTypes["circleTick"] = "circleTick";
    IconTypes["clipboard"] = "clipboard";
    IconTypes["clock"] = "clock";
    IconTypes["close"] = "close";
    IconTypes["comment"] = "comment";
    IconTypes["customReward"] = "customReward";
    IconTypes["refresh"] = "refresh";
    IconTypes["dca"] = "dca";
    IconTypes["delete"] = "delete";
    IconTypes["disabledEditQuestion"] = "disabledEditQuestion";
    IconTypes["dotDotDot"] = "dotDotDot";
    IconTypes["downArrow"] = "downArrow";
    IconTypes["downloadFile"] = "downloadFile";
    IconTypes["duplicate"] = "duplicate";
    IconTypes["editPencil"] = "editPencil";
    IconTypes["editQuestion"] = "editQuestion";
    IconTypes["ellipsis"] = "ellipsis";
    IconTypes["emoji"] = "emoji";
    IconTypes["emojiActive"] = "emojiActive";
    IconTypes["event"] = "event";
    IconTypes["eyeSlash"] = "eyeSlash";
    IconTypes["favouriteOutline"] = "favouriteOutline";
    IconTypes["fileDownload"] = "fileDownload";
    IconTypes["filterActive"] = "filterActive";
    IconTypes["geoArrow"] = "geoArrow";
    IconTypes["geoPin"] = "geoPin";
    IconTypes["heartOutline"] = "heartOutline";
    IconTypes["help"] = "help";
    IconTypes["home"] = "home";
    IconTypes["i"] = "i";
    IconTypes["info"] = "info";
    IconTypes["landscape"] = "landscape";
    IconTypes["launch"] = "launch";
    IconTypes["logoBox"] = "logoBox";
    IconTypes["logout"] = "logout";
    IconTypes["menu"] = "menu";
    IconTypes["mobileSecondaryNav"] = "mobileSecondaryNav";
    IconTypes["more"] = "more";
    IconTypes["myPerks"] = "myPerks";
    IconTypes["myRecognition"] = "myRecognition";
    IconTypes["mySurveys"] = "mySurveys";
    IconTypes["newsletter"] = "newsletter";
    IconTypes["newTab"] = "newTab";
    IconTypes["oldComment"] = "oldComment";
    IconTypes["oldCommented"] = "oldCommented";
    IconTypes["oldReward"] = "oldReward";
    IconTypes["online"] = "online";
    IconTypes["padlock"] = "padlock";
    IconTypes["party"] = "party";
    IconTypes["pause"] = "pause";
    IconTypes["payment"] = "payment";
    IconTypes["people"] = "people";
    IconTypes["perks"] = "perks";
    IconTypes["perksGO"] = "perksGO";
    IconTypes["person"] = "person";
    IconTypes["pin"] = "pin";
    IconTypes["pinFilled"] = "pinFilled";
    IconTypes["play"] = "play";
    IconTypes["playVideo"] = "play-video";
    IconTypes["poll"] = "poll";
    IconTypes["productsInsights"] = "products-insights";
    IconTypes["productsMedical"] = "products-medical";
    IconTypes["productsPerks"] = "products-perks";
    IconTypes["productsRecognition"] = "products-recognition";
    IconTypes["question"] = "question";
    IconTypes["reminder"] = "reminder";
    IconTypes["removeBookmark"] = "removeBookmark";
    IconTypes["report"] = "report";
    IconTypes["restore"] = "restore";
    IconTypes["rewardActive"] = "rewardActive";
    IconTypes["rightArrow"] = "rightArrow";
    IconTypes["seeResults"] = "seeResults";
    IconTypes["sendExampleSurvey"] = "sendExampleSurvey";
    IconTypes["share"] = "share";
    IconTypes["sharedUser"] = "sharedUser";
    IconTypes["simpleFavourite"] = "simpleFavourite";
    IconTypes["simpleFavouriteOutline"] = "simpleFavouriteOutline";
    IconTypes["sort"] = "sort";
    IconTypes["stop"] = "stop";
    IconTypes["summaryComments"] = "summaryComments";
    IconTypes["summaryRecognitions"] = "summaryRecognitions";
    IconTypes["summaryTrophies"] = "summaryTrophies";
    IconTypes["tag"] = "tag";
    IconTypes["trashcan"] = "trashcan";
    IconTypes["upArrow"] = "upArrow";
    IconTypes["user"] = "user";
    IconTypes["values"] = "values";
    IconTypes["visibility"] = "visibility";
    IconTypes["vote"] = "vote";
    IconTypes["voted"] = "voted";
})(IconTypes || (IconTypes = {}));
export default IconTypes;
